import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { LayoutDashboard, BarChart3, Activity, PieChart } from 'lucide-react';
import { IntelligenceLayout } from './IntelligenceLayout';
import DailyBriefingHome from './DailyBriefingHome';
import IntelligenceDashboard from './IntelligenceDashboard';
import RecruiterActivityDashboard from './RecruiterActivityDashboard';
import ClientAcquisitionTracker from './ClientAcquisitionTracker';

const TABS = [
  { key: 'daily-briefing', label: 'Daily Briefing', icon: LayoutDashboard, Component: DailyBriefingHome },
  { key: 'executive-snapshot', label: 'Executive Snapshot', icon: BarChart3, Component: IntelligenceDashboard },
  { key: 'recruiter-activity', label: 'Recruiter Activity', icon: Activity, Component: RecruiterActivityDashboard },
  { key: 'client-acquisition', label: 'Client Acquisition', icon: PieChart, Component: ClientAcquisitionTracker },
];

const DEFAULT_TAB = 'daily-briefing';

export default function CommandCenterHub() {
  const [searchParams, setSearchParams] = useSearchParams();
  const requestedTab = searchParams.get('tab');
  const [activeTab, setActiveTab] = useState(
    TABS.some(t => t.key === requestedTab) ? requestedTab : DEFAULT_TAB
  );

  const handleTabClick = (key) => {
    setActiveTab(key);
    setSearchParams({ tab: key });
  };

  const ActiveComponent = TABS.find(t => t.key === activeTab)?.Component || DailyBriefingHome;
  const extraProps = activeTab === 'daily-briefing'
    ? { initialView: searchParams.get('view') || 'today' }
    : {};

  return (
    <IntelligenceLayout title="Command Center">
      <div className="border-b border-gray-200 bg-white px-6 pt-4 sticky top-0 z-10" data-testid="command-center-hub-tabs">
        <div className="flex items-center gap-1 overflow-x-auto">
          {TABS.map(tab => (
            <button
              key={tab.key}
              onClick={() => handleTabClick(tab.key)}
              data-testid={`command-center-tab-${tab.key}`}
              className={`flex items-center gap-1.5 px-3.5 py-2.5 text-sm font-medium rounded-t-lg border-b-2 whitespace-nowrap transition-colors ${
                activeTab === tab.key
                  ? 'text-[#0A1F44] border-[#D4AF37] bg-[#fdf9ef]'
                  : 'text-gray-500 border-transparent hover:text-[#0A1F44] hover:bg-gray-50'
              }`}
            >
              <tab.icon className="h-3.5 w-3.5" />
              {tab.label}
            </button>
          ))}
        </div>
      </div>
      <ActiveComponent embedded {...extraProps} />
    </IntelligenceLayout>
  );
}
